export function parseAttachmentFilenameFromContentDisposition(
  header: string | undefined,
  fallback: string,
): string {
  if (!header || typeof header !== 'string') {
    return fallback
  }
  const filenameStar = /filename\*=UTF-8''([^;\s]+)/i.exec(header)
  if (filenameStar?.[1]) {
    try {
      return decodeURIComponent(filenameStar[1])
    } catch {
      return fallback
    }
  }
  const filenameQuoted = /filename="([^"]+)"/i.exec(header)
  if (filenameQuoted?.[1]) {
    return filenameQuoted[1].trim()
  }
  const filenameBare = /filename=([^;\s]+)/i.exec(header)
  if (filenameBare?.[1]) {
    return filenameBare[1].replace(/^["']|["']$/g, '').trim()
  }
  return fallback
}

/**
 * Safe download name `organization-logo-{n}.{ext}` — `ext` taken from the public CDN path when
 * present (no network). Used when `Content-Disposition` is not visible to the browser (CORS).
 */
export function buildOrgLogoDownloadFilename(logoIndex: number, publicCdnUrl?: string): string {
  const n = String(logoIndex + 1)
  if (!publicCdnUrl || typeof publicCdnUrl !== 'string') {
    return `organization-logo-${n}.png`
  }
  try {
    const path = new URL(publicCdnUrl).pathname
    const last = path.split('/').filter(Boolean).pop() ?? ''
    const match = /\.([a-zA-Z0-9]{1,8})$/.exec(last)
    if (match?.[1]) {
      return `organization-logo-${n}.${match[1].toLowerCase()}`
    }
  } catch {
    // ignore invalid URL
  }
  return `organization-logo-${n}.png`
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i])
  }
  return globalThis.btoa(binary)
}
